// extracted by mini-css-extract-plugin
export var colorSquare = "_mo-0";
export var danger = "_mo-5";
export var lightPink = "_mo-8";
export var neutralBlue = "_mo-7";
export var neutralYellow = "_mo-6";
export var normal = "_mo-1";
export var primary = "_mo-2";
export var primaryLight = "_mo-3";
export var solidBlack = "_mo-g";
export var solidGreen = "_mo-b";
export var solidLightBlue = "_mo-d";
export var solidNavy = "_mo-c";
export var solidOrange = "_mo-f";
export var solidPink = "_mo-e";
export var solidRed = "_mo-9";
export var solidYellow = "_mo-a";
export var success = "_mo-4";